module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(!_vm.loading) ? [_c('b-button', {
    staticClass: "mt-2 duplicate btn-block col-md-10",
    attrs: {
      "size": "md",
      "variant": "success"
    },
    on: {
      "click": _vm.duplicate
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.duplicate')))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3361918"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duplicate-draft/DuplicateDraft.vue
// module id = 959
// module chunks = 1